import gql from "graphql-tag";

export default gql`
    mutation ($productPriceId: ID!) {
        deleteProductPrice (productPriceId: $productPriceId) {
            success
        }
    }
`;
